module.exports = __webpack_public_path__ + "img/footer-logo.a350d5be.svg";